module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayThin.8236851.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayThin.woff2
// module id = gYA/
// module chunks = 1